<template>
    <y-rogue-wrapper
        name="profileUserInfo"
        type="simple"
        :title="$t('dashboard.profile.title')"
        :user="user"
        :user-metadata="userMetadata"
        :is-edit="!!$route.params.id"
        raised
        :edit-link="editLink"
        @save="$emit('reloadUser')"
    />
</template>

<script>
    export default {
        name: 'DashboardProfile',

        props: {
            user        : Object,
            userMetadata: Object,
        },

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.$t('dashboard.profile.title'),
            };
        },

        computed: {
            /**
             * @inheritdoc
             */
            editLink() {
                return {
                    name  : 'dashboard-profile-edit',
                    params: {
                        id: this.user ? this.user.id : null,
                    },
                };
            },
        },
    };
</script>
